<template>
    <zj-layout-container>
        <zj-layout-main>
            <el-container style="height: 100%;">
            <el-aside width="400px" style="padding: 20px 20px 20px 20px;border-right:solid 1px gray; ">
                <el-container style="height:100%;">
                <el-header style="text-align:left;padding: 4px 4px;">
                <h1 style="display:inline-block;">设备树</h1>
                <el-button :disabled="loading" type="primary" @click="handleLoad" style="float:right;">刷新</el-button>
                </el-header>
                <el-main>
                <el-tree
                    style="height:100%;"
                    v-loading="loading"
                    :element-loading-text="loadingText"
                    node-key="id"
                    :data="tree"
                    :props="defaultProps"
                    :default-expanded-keys="expandedKeys"
                    :check-on-click-node="false"
                    @node-click="handleNodeClick"
                    class="zj-demo-player-tree-device-tree"></el-tree>
                </el-main>
                </el-container>
            </el-aside>
            <el-container style="padding: 10px 10px 10px 20px;">
                <el-main style="padding: 0px 0px;">
                    <div style="text-align:left; width:100%;height:100%;">
                      <el-tabs v-model="selectedTag" class="dock-fill" @tab-click="handleTabClick">
                        <el-tab-pane label="实时预览" name="preview">
                          <ZjCameraPreview
                            ref="previewPlayer"
                            :cameraId="cameraId"
                            :cameraName="cameraName"
                            :streamType="previewPlayerConfigs.streamType"
                            :autoplay="previewPlayerConfigs.autoplay"
                            style="width:100%; height:100%;" />
                        </el-tab-pane>
                        <el-tab-pane label="录像回放" name="playback">
                          <zj-layout-container style="padding: 0px 0px;">
                            <zj-layout-header style="padding: 0px 0px;">
                              <el-form ref="playbackForm" :model="playbackForm" :inline="true" style="margin-bottom:15px;">
                                <el-form-item label="时间范围" style="padding-left:0px;margin-right:0px;margin-bottom:0px;">
                                  <el-date-picker
                                    v-model="playbackTimeRange"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    :clearable="false"
                                    class="zj-demo-player-tree-playback-timerange">
                                  </el-date-picker>
                                </el-form-item>
                                <el-form-item style="margin-right:0px;margin-bottom:0px;">
                                  <el-button type="primary" @click="onPlayback">回放</el-button>
                                </el-form-item>
                              </el-form>
                            </zj-layout-header>
                            <zj-layout-main style="padding: 0px 0px;">
                              <ZjCameraPlayback
                                ref="playbackPlayer"
                                :cameraId="cameraId"
                                :cameraName="cameraName"
                                :streamType="playbackPlayerConfigs.streamType"
                                :autoplay="playbackPlayerConfigs.autoplay"
                                :beginTime="playbackTimeRange[0]"
                                :endTime="playbackTimeRange[1]"
                                style="width:100%; height:100%;" />
                            </zj-layout-main>
                          </zj-layout-container>
                        </el-tab-pane>
                      </el-tabs>
                    </div>
                </el-main>
            </el-container>
            </el-container>
        </zj-layout-main>
    </zj-layout-container>
</template>

<script>
import ZJApp from '../../../../app'
const ZJPlayer = ZJApp.ZJPlayer;
console.log(ZJPlayer);
const MediaCenter = ZJPlayer.MediaCenter;
const MSG = ZJPlayer.MediaCenterMsg;
const PageSize = 100;
export default {
    name: 'ZjDemoPlayerTree',
    controller: 'UI',
    action: 'playerTree',
    data () {
      let beginTime = new Date();
      let endTime = new Date();
      beginTime.setTime(beginTime.getTime() + (-1*60*60*1000));
      return {
        regions: [],
        cameras: [],
        tree: [{label:''}],
        defaultProps: {
          children: 'children',
          label: 'label',
          isLeaf: 'isCamera'
        },
        expandedKeys: [],
        loading: false,
        loadingText: '',
        previewPlayerConfigs: {
          streamType: 1, //0 - 主码流；1 - 子码流
          autoplay: false
        },
        playbackPlayerConfigs: {
          streamType: 1, //0 - 主码流；1 - 子码流
          autoplay: false
        },
        cameraId: '',
        cameraName: '',
        selectedTag: 'preview',
        playbackTimeRange: [ beginTime, endTime ]
      };
  },
  created() {
    this.mc = new MediaCenter();
    this.mc.on('connected', ()=>this.onConnected());
    this.mc.on('msg', e=>this.onRecv(e));
    this.mc.on('error', e=>this.onError(e));
    this.handleLoad();
  },
  methods: {

    // 加载设备树
    handleLoad() {
      this.regions = [];
      this.cameras = [];
      this.loading = true;
      this.loadingText = '加载区域中...';
      if (this.mc.$connected) {
        this.beginGetRegions();
      }
      else {
        this.mc.connect()
          .then(()=>this.beginGetRegions());
      }
    },

    // 成功连接到媒体中心
    onConnected() {
      //this.beginGetRegions();
    },

    beginGetRegions() {
      // 发送命令：分页获取区域信息
      this.pageNo = 1;
      this.mc.sendCmd(MSG.GET_PAGED_REGION_LIST, {
        pageNo: this.pageNo,
        pageRows: PageSize
      });
    },

    onError(e) {
      console.error(e);
      let msg = e && e.error && e.error.message ? e.error.message : e;
      this.$message.error('出错了: ' + msg);
      this.loading = false;
    },

    // 接收到媒体中心的响应
    onRecv(e) {
      console.log(e);
      const msg = e.data;
      if (msg.isResponse()) {
        switch(msg.msgCode) {
          case MSG.GET_PAGED_REGION_LIST:
            this.onGetRegions(msg.getJsonData());
            break;
          case MSG.GET_PAGED_CAMERA_LIST:
            this.onGetCameras(msg.getJsonData());
            break;
        }
      }
    },

    // 处理获取区域的响应
    onGetRegions(r) {
      console.log(r);
      if (r && r.code == "0" && r.data && r.data.list) {
        const data = r.data;
        const list = data.list;
        for (let i = 0; i < list.length; i++) {
          this.regions.push(list[i]);
        }

        if (this.regions.length >= data.total) {
          this.loadingText = '加载区域...100%';
          this.onGetRegionCompleted();
        }
        else {
          if (data.total > 0) {
            this.loadingText = '加载区域...' + parseInt(this.regions.length * 100 / data.total) + '%';
          }
          // 获取下一页
          this.pageNo++;
          this.mc.sendCmd(MSG.GET_PAGED_REGION_LIST, {
            pageNo: this.pageNo,
            pageRows: PageSize
          });
        }
      }
      else {
        console.error(r&&r.msg ? r.msg : '未获取到区域信息');
        this.$message.error('出错了: 无区域信息');
      }
    },

    // 已经获取到所有区域
    onGetRegionCompleted() {
      console.log('onGetRegionCompleted', this.regions);
      // 获取监控点信息
      this.pageNo = 1;
      this.loadingText = '加载监控点...';
      this.mc.sendCmd(MSG.GET_PAGED_CAMERA_LIST, {
        pageNo: this.pageNo,
        pageRows: PageSize
      });
    },

    // 获取到摄像机
    onGetCameras(r) {
      console.log(r);
      if (r && r.code == "0" && r.data && r.data.list) {
        const data = r.data;
        const list = data.list;
        for (let i = 0; i < list.length; i++) {
          this.cameras.push(list[i]);
        }

        if (this.cameras.length >= data.total) {
          this.loadingText = '加载监控点...100%';
          this.onGetCameraCompleted();
        }
        else {
          if (data.total > 0) {
            this.loadingText = '加载监控点...' + parseInt(this.cameras.length * 100 / data.total) + '%';
          }
          // 获取下一页
          this.pageNo++;
          this.mc.sendCmd(MSG.GET_PAGED_CAMERA_LIST, {
            pageNo: this.pageNo,
            pageRows: PageSize
          });
        }
      }
      else {
        console.error(r&&r.msg ? r.msg : '未获取到监控点信息');
        this.$message.error('出错了: 无监控点信息');
      }
    },
    
    // 已经获取到所有摄像机
    onGetCameraCompleted() {
      console.log('onGetCameraCompleted', this.cameras);
      this.buildTree();
    },

    // 构建设备树
    buildTree() {
      const tree = [];
      const regionDic = {};
      const cameraDic = {};
      const expandedKeys = [];

      for (let i = 0;i < this.regions.length; i++) {
        let region = this.regions[i];
        regionDic[region.indexCode] = {
          label: region.name,
          id: region.indexCode,
          parent: region.parentIndexCode
        };
        expandedKeys.push(region.indexCode);
      }

      for (let i = 0;i < this.regions.length; i++) {
        let region = this.regions[i];
        region = regionDic[region.indexCode];
        if (region.parent) {
          let parent = regionDic[region.parent];
          if (parent) {
            parent.children = parent.children || [];
            parent.children.push(region);
          }
          else {
            tree.push(region);
          }
        }
        else {
          tree.push(region);
        }
      }

      console.log(tree);

      const otherRegion = {
        label: '其他',
        id: 'other-region',
        parent: null,
        children: []
      };


      for (let i = 0;i < this.cameras.length; i++) {
        let camera = this.cameras[i];
        cameraDic[camera.cameraIndexCode] = {
          label: camera.cameraName,
          id: camera.cameraIndexCode,
          parent: camera.regionIndexCode,
          isCamera: true,
          cameraType: camera.cameraType,
          cameraTypeName: camera.cameraTypeName
        };
      }

      for (let i = 0;i < this.cameras.length; i++) {
        let camera = this.cameras[i];
        camera = cameraDic[camera.cameraIndexCode];
        if (camera.parent) {
          let parent = regionDic[camera.parent];
          if (parent) {
            parent.children = parent.children || [];
            parent.children.push(camera);
          }
          else {
            otherRegion.children.push(camera);
          }
        }
        else {
          otherRegion.children.push(camera);
        }
      }


      if (otherRegion.children.length > 0) {
        tree.push(otherRegion);
        expandedKeys.push(otherRegion.id);
      }

      console.log(tree);

      this.tree = tree;
      this.expandedKeys = expandedKeys;

      this.loading = false;
    },

    // 点击设备树中的某一个节点
    handleNodeClick(data) {
      if (data && data.isCamera) {
        this.cameraId = data.id;
        this.cameraName = data.label;
        let player = this.selectedTag === 'preview' ? this.$refs.previewPlayer:this.$refs.playbackPlayer;
        let autoplay = this.selectedTag === 'preview' ? this.previewPlayerConfigs.autoplay:this.playbackPlayerConfigs.autoplay;
        //如果自动播放或者正在播放时，开始播放新选择的监控
        if (autoplay || player.isPlaying()) {
          player.play();
        }
      }
    },

    onPlayback() {
      let player = this.$refs.playbackPlayer;
      player.play();
    },

    handleTabClick(/*tab, event*/) {
        this.$nextTick(()=>{
          let arr = [this.$refs.previewPlayer,this.$refs.playbackPlayer];
          for (let i = 0; i < arr.length; i++) {
            let player = arr[i];
            let opts = {
              width: player.$el.offsetWidth,
              height: player.$el.offsetHeight
            };
            //console.log(i, opts);
            player.resize(opts);
          }
        });
    }

  }
}
</script>

<style lang="scss">
.zj-demo-player-tree-device-tree {
  .el-tree-node.is-current {
    background-color: rgba(7, 78, 133, 0.7);
  }
}
.zj-demo-player-tree-playback-timerange {
  &,&.el-date-editor--datetimerange.el-input__inner {
    width: 420px;
  }
  
  .el-range-input {
    width: 180px;
    margin: 0px 4px;
    background-color: transparent !important;
  }
  .el-range-separator {
    width: 30px;
  }
}
html.zj-app-pc .el-date-editor.zj-demo-player-tree-playback-timerange {
  .el-range-input {
    background-color: transparent !important;
  }
}
</style>
